import { FC } from 'react';

import { formatTime, getAnalyticsDate } from '@rikstv/play-common/src/utils/date/date.utils';

import { Program } from '../../../forces/channels/channel.types';

import styles from './TvGuideProgramTitle.module.css';

interface Props {
  program: Program;
  isCurrentProgram?: boolean;
  className?: string;
}

export const TvGuideProgramTitle: FC<Props> = ({ program, isCurrentProgram, className }) => (
  <div className={`${styles.title} ${!isCurrentProgram && styles.notCurrentPrograms}`}>
    {isCurrentProgram ? (
      <span className={`${styles.timeCurrentProgram} ${className}`}>Nå</span>
    ) : (
      <time className={className} itemProp="startDate" dateTime={getAnalyticsDate(program.time)}>
        {formatTime(program.time)}
      </time>
    )}
    <span className={`${styles.name} ${className}`} itemProp="name" title={program.name}>
      {program.name}
    </span>
  </div>
);
